import { simulatorsValues } from './simulatorsValues';

export const environment = {
  apiBaseUrl: 'https://portagile.fr/api',
  ...simulatorsValues
};
